import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  href: string;
  className?: string;
}
export function CTAButton({
  children,
  href,
  className = ''
}: CTAButtonProps) {
  return <a href={href} target="_blank" rel="noopener noreferrer" className={`block w-full border-b-4 border-[#8e7130] bg-brand-gold px-3 py-3 text-center font-subheading text-sm font-extrabold uppercase leading-tight tracking-wide text-brand-forest shadow-[0_5px_0_#8e7130,0_9px_18px_rgba(70,85,62,0.18)] transition duration-150 hover:-translate-y-0.5 hover:bg-[#d2b264] focus:outline-none focus:ring-4 focus:ring-brand-gold/35 active:translate-y-1 active:border-b-0 sm:text-base ${className}`} data-id="element-21" data-mp="2kyepxcs9ae0q">
      {children}
    </a>;
}